
// ------------------------------------------------------------------------
// STATE
// ------------------------------------------------------------------------
const state = {
    activeUrl: '',
    namespace: '',
    isLoading: false, // indicates when e.g. infinite scroll is loading
};


// ------------------------------------------------------------------------
// MUTATIONS
// ------------------------------------------------------------------------
const mutations = {
    setActiveUrl(state, activeUrl) {
        state.activeUrl = activeUrl;
    },
    setNamespace(state, namespace) {
        state.namespace = namespace;
    },
    setLoading(state, isLoading) {
        state.isLoading = isLoading;
    },
};


// ------------------------------------------------------------------------
// ACTIONS
// ------------------------------------------------------------------------
const actions = {

};


// ------------------------------------------------------------------------
// GETTERS
// ------------------------------------------------------------------------
const getters = {

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
